import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useHistory, useParams} from "react-router";
import updateUser, {getUserForUpdate, UserForUpdateDto, UserRoles} from "core/application/users/updateUser";
import {commandRequest, queryRequest} from "../../common/RequestUtils";
import notification from "../../common/components/feedback/Notification";
import {Col, Row, Skeleton} from "antd";
import {Form as FormikForm, Formik} from "formik";
import Card from "../../common/components/dataDisplay/Card";
import Input from "../../common/components/dataEntry/formik/FormikInputField";
import Select from "../../common/components/dataEntry/formik/FormikSelectField";
import FormSaveCancelButtons from "../../common/components/forms/SaveCancelFormButtons";
import * as Yup from "yup";
import {UserPermissions} from "core/application/users/updateUser";

export const UPDATE_USER_PATH = "update-user"
const formValidator = (translate: any) =>
    Yup.object({
        firstName: Yup.string()
            .required(translate("general.required"))
            .nullable()
            .typeError(translate("general.required")),
    });

const UpdateUser : React.FC = () => {
    const { t: translate } = useTranslation();
    const history = useHistory();
    const { id } = useParams();
    const [item, setItem] = useState<UserForUpdateDto | null>(null)
    const [loading, setLoading] = useState(false);

    useEffect( () =>{
        (async () => {
            await updateForm();
        })()
    },[])

    const updateForm = async() =>{
        setLoading(true);
        setItem(await queryRequest(() => getUserForUpdate(id)));
        setLoading(false);
    }
    const onSubmit = async (values : any) => {
        const result = await commandRequest(() => updateUser(values))
        if (!result.errors) {
            notification.open({
                message: translate("general.saved").replace(
                    "[]",
                    translate("users.name")
                ),
                type: "success"
            });
            history.goBack();
        } else {
            notification.open({message: result.errors[0], type: "error"});
        }
    }
    return (
        <Skeleton
            active
            loading={loading}
            paragraph={{ rows: 6, className: "p-64 color-gray-5" }}
            title={false}
        >
            {" "}
            {item && (
                <Formik
                    enableReinitialize={true}
                    initialValues={item}
                    validationSchema={formValidator(translate)}
                    onSubmit={() => {}}
                >
                    {formik => (
                        <div>
                            <Card
                                bordered={true}
                                title={id ? translate("users.edit"): translate("users.add")}
                            >
                                <FormikForm className={'container'}>
                                    <Row>
                                        <Col span={24}>
                                            <Input
                                                name="firstName"
                                                label={`Emri`}
                                                placeholder={`Emri`}
                                            >
                                            </Input>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Input
                                                name="lastName"
                                                label={`Mbiemri`}
                                                placeholder={`Mbiemri`}
                                            >
                                            </Input>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Select
                                                name="userPermissions"
                                                showSearch={true}
                                                label={`Privilegje`}
                                                placeholder={`Privilegje`}
                                                mode="multiple"
                                                defaultValue={item?.userPermissions.length ? item.userPermissions : []}
                                            >
                                                {UserPermissions.map((index) => (
                                                    <option key={index.id} value={index.id}>
                                                        {index.name}
                                                    </option>
                                                ))}
                                            </Select>
                                        </Col>
                                    </Row>
                                </FormikForm>
                            </Card>
                            <div className={"text-center mb-16"}>
                                <FormSaveCancelButtons
                                    disabledSave={
                                        !formValidator(translate).isValidSync(formik.values)
                                    }
                                    onButtonClick={() => onSubmit(formik.values)}
                                    loading={loading}
                                />
                            </div>
                        </div>
                    )}
                </Formik>
            )}
        </Skeleton>
    )
}

export default UpdateUser;